export default {"src":"/_next/static/media/youTube.8b7f71a3.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};